import React, { Component } from "react";
import { connect } from "react-redux";
import Steps from "./Steps";
import { ROUTE_HOME } from "../../../shared/constants";
import Input from "../../../../shared/Input/Input";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import Select from "./../../../../shared/Select/Select";
import { sendCreateUpdateBank } from "../../../shared/requests-api";
import {
	isAllFieldsEmpty,
	returnUserJWT,
	getUserToken,
	getPhoneByState,
	fidelityIsNational,
	isValidCellPhone,
	scrollToComponent
} from "../../../shared/utils";
import { getFidelityLogin } from "../../../shared/requests-api";
import Modal from "../../../../shared/Modal/Modal";
import Video from "../../../../shared/Video/Video";
import Loading from "../../../../shared/Loading/Loading";
import { isMobile } from "../../../../../js/components/searchform/utils/common";
import VMasker from "vanilla-masker";

const mmPhone = getPhoneByState(returnUserJWT().state);

class RegisterBankDetailsAndLogin extends Component {
	constructor() {
		super();
		this.state = {
			latam: false,
			gol: false,
			keepData: true,
			errors: {
				login: undefined,
				password: undefined,
				phone: undefined,
				rescuePassword: undefined,
				agency: undefined,
				account: undefined,
				dacAccount: undefined
			},
			hasLogin: undefined,
			banks: []
		};

		this.submitAndNextStep = this.submitAndNextStep.bind(this);
		this.saveAndPrevStep = this.saveAndPrevStep.bind(this);
		this.validForm = this.validForm.bind(this);
		this.confirmNextStep = this.confirmNextStep.bind(this);
		this.selectBankOption = this.selectBankOption.bind(this);
		this.validateOffer = this.validateOffer.bind(this);
		this.searchLogin = this.searchLogin.bind(this);
	}

	componentDidMount() {
		this.handleLoginAndBank(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.handleLoginAndBank(nextProps);
	}

	handleLoginAndBank(props) {
		let self = this;
		const { form, banks } = props;
		let login = this.state.login;

		let errors = this.state.errors;

		if (form) {
			this.setState(form);
			login = form.login;
			phone = form.phone;

			errors = form.errors;

			if (form.fidelity) {
				this.setState({ latam: form.fidelity.label == "Latam", gol: form.fidelity.label == "Gol" });
			}

			this.searchLogin(form.fidelityId, form.loginRequestDone);
		}

		if (banks) {
			let banksMap = banks.map(bank => {
				return { value: bank.idBank, label: bank.name };
			});
			self.setState({
				banks: banksMap
			});
		}

		const user = returnUserJWT();
		if (user && !login && form && fidelityIsNational(form.fidelityId) && user.ssn) {
			errors.login = "";
			this.setState({ login: String(user.ssn).replace(/[^0-9]/g, ""), errors });
		}

		if (user) {
			this.setState({ cpfcnpj: user.ssn });
		}

		this.setState({ showSmilesPhone: window._mmSmilesPhoneD }); // _mmSmilesPhone -> OFW-480 - Inserir campo para telefone no programa da Smiles (teste a/b) - Desabilitado até correção do backend, para voltar a ativar, basta remover o "D" do final

		this.validateOffer(props);
	}

	validateOffer(props) {
		const { offers, form } = props;

		// Valida se está tentando fazer um programa que já tem oferta em venda ou bloqueada
		if (offers && form) {
			offers.forEach(offer => {
				if (
					offer.fidelity.airlineAcronym == form.fidelity.label &&
					(!offer.editable || offer.status == 3)
				) {
					localStorage.removeItem("CreateOffer");
					window.location.href = ROUTE_HOME;
				}
			});
		}
	}

	searchLogin(fidelityId, loginRequestDone) {
		const token = getUserToken();
		let self = this;

		if (token && fidelityId && !loginRequestDone) {
			this.setState({ loading: true });
			getFidelityLogin(token, fidelityId)
				.then(response => {
					const { username: login, password, pwAwardSecondary: rescuePassword, rg } = response.data;
					let phone = response.data.phone;
					const user = returnUserJWT();
					let errors = self.state.errors;
					if (user && fidelityIsNational(fidelityId)) {
						errors.login = "";
					}

					errors.login = "";
					errors.password = undefined;
					errors.phone = "";
					errors.rescuePassword = undefined;

					if (self.state.gol) {
						phone = undefined;
					}

					self.setState({
						loginFidelityId: fidelityId,
						login: fidelityIsNational(fidelityId)
							? String(user.ssn).replace(/[^0-9]/g, "")
							: String(login),
						password: String(password),
						phone: phone,
						rescuePassword: String(rescuePassword),
						encrypted: true,
						loginRequestDone: true,
						hasLogin: true,
						loading: false,
						hasOffers: true
					});
				})
				.catch(res => {
					const user = returnUserJWT();
					let errors = [];
					let login = undefined;
					let phone = undefined;
					let hasLogin = false;

					if (user && fidelityIsNational(fidelityId)) {
						errors.login = "";
						login = String(user.ssn).replace(/[^0-9]/g, "");
						hasLogin = true;
					}

					self.setState({
						loginFidelityId: fidelityId,
						login: login,
						password: undefined,
						phone: phone,
						rescuePassword: undefined,
						encrypted: false,
						loginRequestDone: true,
						hasLogin: hasLogin,
						loading: false,
						hasOffers: false,
						errors
					});
				});
		}
	}

	submitAndNextStep() {
		const token = getUserToken();
		const { bank, agency, dacAgency, account, dacAccount, cpfcnpj } = this.state;
		let self = this;

		self.setState({ loadingMessage: "Estamos salvando os dados..." });
		sendCreateUpdateBank(token, bank, agency, dacAgency, account, dacAccount, cpfcnpj)
			.then(response => {
				self.props.next(self.state);
			})
			.catch(response => {
				console.log(response);
				self.setState({ loadingMessage: response.data.message });
			});
	}

	saveAndPrevStep() {
		this.props.prev(this.state);
	}

	validForm(event) {
		const { form } = this.props;
		const { errors, gol } = this.state;
		const user = returnUserJWT();
		let value = event.target.type == "checkbox" ? event.target.checked : event.target.value;

		if (event.target.name == "account") {
			value = value.replace(/\D/g, "");
		}

		if (event.target.name == "agency") {
			value = value.replace(/\D/g, "");
			this.moveOnMax(event, "dacAgencyId");
		}

		if (event.target.name == "dacAccount") {
			value = value.replace(/[^0-9xX]/g, "");
		}

		if (event.target.name == "dacAgency") {
			value = value.replace(/[^0-9xX]/g, "");
		}

		errors[event.target.name] = value
			? ""
			: event.target.name == "password"
			? (errors.password = "Senha do programa de fidelidade não confere")
			: `${event.target.title || event.target.name} não confere`;

		if (event.target.name == "login" && (!event.target.value || event.target.value.length < 4)) {
			errors.login = "O usuário deve ter, no mínimo, 4 dígitos";
		}

		if (
			event.target.name == "login" &&
			(!fidelityIsNational(form.fidelityId) &&
				(event.target.value ==
					String(user.ssn).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4") ||
					event.target.value == String(user.ssn).replace(/[^0-9]/g, "")))
		) {
			errors.login = "O usuário do programa de fidelidade não confere";
		}

		if (event.target.name == "keep-data" && !event.target.checked && encrypted) {
			this.setState({ password: undefined, rescuePassword: undefined, encrypted: false });
		}

		if (event.target.name == "keep-data") {
			errors["keep-data"] = "";
		}

		if (event.target.name == "password" && gol) {
			if (isNaN(value)) {
				errors.password = "A senha da Smiles deve ter apenas 4 números.";
			} else if (value.length != 4) {
				errors.password = "A senha da Smiles deve ter apenas 4 números.";
			}
		}

		if (event.target.name == "rescuePassword") {
			if (value.length < 5) {
				errors.rescuePassword =
					'A senha de resgate deve ter 5 dígitos. Saiba <u class="request-here" onclick="document.querySelector(\'#howToRequest\').click()">solicitar aqui</u>';
			} else if (isNaN(value)) {
				errors.rescuePassword =
					'A senha de resgate deve ter apenas números. Saiba <u class="request-here" onclick="document.querySelector(\'#howToRequest\').click()">solicitar aqui</u>';
			}
		}

		if (event.target.name == "phone") {
			if (value.length < 1) {
				errors.phone = "Campo obrigatório";
			} else if (value.charAt(5) != "" && value.charAt(5) != "9") {
				errors.phone = "Número de celular inválido";
			}
		}

		this.setState({ [event.target.name]: value, errors });
	}

	isValid = () => {
		const {
			agency,
			bank,
			bankOption,
			account,
			dacAccount,
			dacAgency,
			latam,
			gol,
			login,
			password,
			rescuePassword,
			phone,
			errors
		} = this.state;

		let valid = agency && bankOption && dacAccount && account && login && password;
		let phoneValidated = isValidCellPhone(phone);
		isAllFieldsEmpty(errors, "agency", "dacAccount", "account", "login", "password");

		if (bank == 45 && valid) {
			valid = dacAgency && isAllFieldsEmpty(errors, "dacAgency");
		}

		if (latam) {
			valid =
				valid &&
				rescuePassword &&
				phoneValidated &&
				isAllFieldsEmpty(errors, "rescuePassword", "phone");
		}

		return valid;
	};

	confirmNextStep() {
		const {
			bankOption,
			agency,
			bank,
			account,
			cpfcnpj,
			errors,
			dacAccount,
			dacAgency,
			latam,
			gol,
			rescuePassword,
			login,
			password,
			phone
		} = this.state;
		if (!this.isValid()) {
			if (password == "" || password == undefined) {
				errors.password = "Campo obrigatório";
			}
			if (login == "" || login == undefined) {
				errors.login = "Campo obrigatório";
			}
			if (gol) {
				if (phone == "" || phone == undefined) {
					errors.phone = "Campo obrigatório";
				}
			}
			if (latam) {
				if (rescuePassword == "" || rescuePassword == undefined) {
					errors.rescuePassword = "Campo obrigatório";
				}
				if (phone == "" || phone == undefined) {
					errors.phone = "Campo obrigatório";
				} else if (!isValidCellPhone(phone)) {
					errors.phone = "Número de celular inválido";
				}
			}
			if (cpfcnpj == "" || cpfcnpj == undefined) {
				errors.cpfcnpj = "Campo obrigatório";
			}
			if (dacAccount == "" || dacAccount == undefined) {
				errors.dacAccount = "Campo obrigatório";
			}
			if (account == "" || account == undefined) {
				errors.account = "Campo obrigatório";
			}
			if (agency == "" || agency == undefined) {
				errors.agency = "Campo obrigatório";
			}
			if (!bankOption) {
				errors.bankOption = "Campo obrigatório";
			}
			if (bank == 45) {
				if (dacAgency == "" || dacAgency == undefined) {
					errors.dacAgency = "Campo obrigatório";
				}
			}
			this.setState({ errors });
		} else {
			this.submitAndNextStep();
		}
	}

	selectBankOption(bankOption) {
		const { errors } = this.state;
		errors.bankOption = "";
		this.setState({ bankOption, bank: bankOption.value, errors });
	}

	moveOnMax(event, nextFieldID) {
		const { bank } = this.state;
		if (bank == 45) {
			let value = event.target.value;
			if (value.length >= event.target.maxLength) {
				document.getElementById(nextFieldID).focus();
			}
		}
	}

	handleCheck(options) {
		const { errors, login } = this.state;
		const { form } = this.props;
		const user = returnUserJWT();
		if (
			!fidelityIsNational(form.fidelityId) &&
			(login == String(user.ssn).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4") ||
				login == String(user.ssn).replace(/[^0-9]/g, ""))
		) {
			errors.login = "O usuário do programa de fidelidade não confere";
		}
		this.setState({ keepData: options[0].checked, errors });
	}

	renderInputs() {
		const {
			latam,
			gol,
			login,
			password,
			rescuePassword,
			errors,
			encrypted,
			keepData,
			hasLogin,
			loading,
			showVideoPassword,
			showVideoPhone
		} = this.state;
		const { form } = this.props;
		const telMask = ["(99) 9999-9999", "(99) 9 9999-9999"];
		let phone = this.state.phone;
		phone =
			phone !== undefined
				? VMasker.toPattern(phone, phone.length == 10 ? telMask[0] : telMask[1])
				: undefined;

		let optionKeepData = [
			{
				label: "Manter dados de acesso do último anúncio",
				name: "keep-data",
				checked: keepData
			}
		];

		if (loading) {
			return <Loading label="Verificando se existe usuário cadastrado..." />;
		}

		if (latam) {
			return (
				<div>
					<div className="row">
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								autoComplete="off"
								label="Usuário do programa de fidelidade*"
								placeholder="Insira o usuário"
								name="login"
								value={login}
								errorMessage={errors.login}
								disabled={hasLogin || (keepData && encrypted)}
								required
								data-action="login-offer-login"
							/>
						</div>
						<div
							className="col-xs-16 col-md-8 form-group fidelity-password"
							onClick={
								(!keepData || !encrypted) &&
								isMobile() &&
								(() => scrollToComponent(".fidelity-password"))
							}
						>
							<Input
								autoComplete="off"
								label="Senha do programa de fidelidade*"
								placeholder="Inserir senha"
								value={password}
								name="password"
								type="password"
								autocomplete="off"
								errorMessage={errors.password}
								disabled={keepData && encrypted}
								required
								data-action="login-offer-password"
							/>
						</div>
					</div>
					{this.state.hasOffers ? (
						<div className="row">
							<div className="col-md-16 keep-data">
								<Checkbox
									id="keep-data"
									name="keep-data"
									onChange={options => this.handleCheck(options)}
									options={optionKeepData}
									data-action="login-offer-keep-data-checkbox"
								/>
							</div>
						</div>
					) : null}
					<div className="row">
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								autoComplete="off"
								label={
									<div className="rescue-password-label">
										Senha de resgate da {form.fidelity.name}*{" "}
										<span
											id="howToRequest"
											className="text-right how-to-request"
											onClick={() => this.setState({ showVideoPassword: true })}
										>
											como solicitar
										</span>
									</div>
								}
								placeholder={`Inserir senha de resgate da ${form.fidelity.name}`}
								value={rescuePassword}
								name="rescuePassword"
								type="password"
								autocomplete="off"
								errorMessage={errors.rescuePassword}
								disabled={keepData && encrypted}
								maxLength="5"
								required
								data-action="login-offer-rescue-password"
							/>
						</div>
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								autoComplete="off"
								label={`Telefone cadastrado na ${form.fidelity.name}*`}
								placeholder="(  )     -    "
								name="phone"
								value={phone}
								pattern="\d*"
								inputMode="numeric"
								maskpattern={telMask}
								errorMessage={errors.phone}
								tooltip={`Atenção! Sua oferta só será aprovada se este telefone for o mesmo cadastrado na ${form.fidelity.name}.`}
								tooltipDirection={isMobile() ? "left" : "up"}
								required
								data-action="login-offer-phone"
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-16 col-md-8 sale-procedures">
							<p className="guarantee-sale">
								<span className="guarantee24h">Garanta suas vendas 24 horas</span> A {form.fidelity.name} envia
								um SMS de confirmação para cada emissão de passagem. Adicione nosso telefone na sua
								conta {form.fidelity.name} e deixe o restante com a gente. Além de possibilitar suas vendas
								fora do horário comercial, nós cuidaremos de todo o procedimento de emissão.
							</p>
							<p className="see-the-video" onClick={() => this.setState({ showVideoPhone: true })}>
								Clique aqui e veja o passo a passo em vídeo
							</p>
							<p>
								1 - Entre no site da{" "}
								<span>
									<a
										className="multiplus-link"
										target="_blank"
										rel="noopener noreferrer"
										href={form.fidelity.link}
										data-action="login-offer-multiplus"
									>
										{form.fidelity.name}
									</a>
								</span>
								.
							</p>
							<p>2 - Clique em “Minha Conta”, na parte superior da tela. </p>
							<p>3 - Clique em “Meu Cadastro” (Menu lateral). </p>
							<p>4 - Clique na aba "Dados de Contato". </p>
							<p>5 - Adicione um novo telefone com o número: {mmPhone}.</p>
							<p>6 - Clique em “Salvar”.</p>
							<p>
								7 - Informe esse mesmo telefone no campo “Telefone cadastrado na {form.fidelity.name}” desta
								página.
							</p>
							<p>
								Quer facilitar ainda mais suas vendas? Baixe o app da MaxMilhas, mantenha sua
								internet ativa e envie pra gente o código de forma automática.
							</p>
						</div>
						<div className="col-xs-16 col-md-8 latam-important-info">
							<p className="title-important-info">INFORMAÇÕES IMPORTANTES</p>
							<p>
								• Para facilitar a emissão de passagens e agilizar suas vendas, poderemos incluir ou
								alterar o telefone do seu cadastro no programa de fidelidade, combinado?
							</p>
							<p>
								• O pagamento da venda de suas milhas será feito em até 33 dias corridos a partir da
								data de emissão da passagem em seu fidelidade.
							</p>
							<p>
								• As vendas de milhas são feitas de forma parcial, de acordo com a quantidade de
								milhas necessárias para o voo escolhido pelo comprador.
							</p>
							<p>
								• Não é possível cadastrar milhas de outras pessoas. Você deve ser o titular do
								fidelidade e do cadastro na MaxMilhas.
							</p>
						</div>
					</div>
					<Video
						description={
							<iframe
								width={isMobile() ? window.screen.availWidth : "560"}
								height="315"
								src="https://www.youtube.com/embed/mUy2d1ggvhc"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							/>
						}
						show={showVideoPassword}
						onClose={() => this.setState({ showVideoPassword: false })}
						fixed={true}
					/>
					<Video
						description={
							<iframe
								width={isMobile() ? window.screen.availWidth : "560"}
								height="315"
								src="https://www.youtube.com/embed/Pt734r9K3mc"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							/>
						}
						show={showVideoPhone}
						onClose={() => this.setState({ showVideoPhone: false })}
						fixed={true}
					/>
				</div>
			);
		} else {
			return (
				<React.Fragment>
					<div className="col-xs-16 col-md-8 form-group">
						<Input
							autoComplete="off"
							label="Usuário do programa de fidelidade*"
							placeholder="Insira o usuário"
							value={login}
							name="login"
							errorMessage={errors.login}
							disabled={
								fidelityIsNational(form.fidelityId)
									? hasLogin || (keepData && encrypted)
									: keepData && encrypted
							}
							required
							data-action="login-offer-login"
						/>
					</div>
					<div
						className="col-xs-16 col-md-8 form-group fidelity-password"
						onClick={
							(!keepData || !encrypted) &&
							isMobile() &&
							(() => scrollToComponent(".fidelity-password"))
						}
					>
						<Input
							autoComplete="off"
							label="Senha do programa de fidelidade*"
							placeholder="Inserir senha"
							name="password"
							type="password"
							autocomplete="off"
							value={password}
							errorMessage={errors.password}
							disabled={keepData && encrypted}
							required
							data-action="login-offer-password"
							maxLength={gol ? 4 : null}
						/>
					</div>
					{this.state.hasOffers ? (
						<div className="col-xs-16">
							<Checkbox
								className="col-xs-16"
								id="keep-data"
								name="keep-data"
								onChange={options => this.handleCheck(options)}
								options={optionKeepData}
								data-action="login-offer-keep-data-checkbox"
							/>
						</div>
					) : null}
					{showSmilesPhone && gol && (
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								autoComplete="off"
								label="Telefone cadastrado na Smiles*"
								placeholder="(  )     -    "
								name="phone"
								value={phone}
								maskpattern={telMask}
								errorMessage={errors.phone}
								tooltip="Atenção! Sua oferta só será aprovada se este telefone for o mesmo cadastrado na Smiles."
								tooltipDirection="up"
								required
								data-action="login-offer-phone"
							/>
						</div>
					)}
					<div className="col-xs-16 important-info">
						<p className="title-important-info">INFORMAÇÕES IMPORTANTES</p>
						<p>
							• Para facilitar a emissão de passagens e agilizar suas vendas, poderemos incluir ou
							alterar o telefone do seu cadastro no programa de fidelidade, combinado?
						</p>
						<p>
							• O pagamento da venda de suas milhas será feito em até 33 dias corridos a partir da
							data de emissão da passagem em seu fidelidade.
						</p>
						<p>
							• As vendas de milhas são feitas de forma parcial, de acordo com a quantidade de
							milhas necessárias para o voo escolhido pelo comprador.
						</p>
						<p>
							• Não é possível cadastrar milhas de outras pessoas. Você deve ser o titular do
							fidelidade e do cadastro na MaxMilhas.
						</p>
					</div>
				</React.Fragment>
			);
		}
	}

	render() {
		const {
			banks,
			bankOption,
			agency,
			bank,
			account,
			cpfcnpj,
			errors,
			dacAccount,
			dacAgency,
			loadingMessage,
			showLoading
		} = this.state;

		return (
			<section className="login-offer row no-margin">
				<form className="form-offer block-center" onChange={this.validForm}>
					<div className="col-xs-16 text-center hidden-xs">
						<span className="form-offer--title">
							Dados Bancários
							<span className="form-offer--title--subtitle">
								Precisamos dos seus dados bancários para realizar o pagamento das vendas feitas por
								você na MaxMilhas. <br />
								<strong>Mas, atenção!</strong> O titular da conta bancária deve ser o mesmo titular
								das milhas. Combinado?
							</span>
						</span>
					</div>
					<div className="row">
						<div className="col-xs-16 col-md-6 form-group">
							<Input
								className="account-bank-details--input--document"
								label="CPF/CNPJ"
								placeholder="XXX.XXX.XXX-XX"
								name="cpfcnpj"
								disabled
								value={cpfcnpj}
								data-action="register-bank-details-cpfcnpj"
							/>
						</div>
						<div className="col-xs-16 col-md-5 form-group">
							<label className="account-bank-details--label" htmlFor="bank-select">
								Banco*
							</label>
							<Select
								id="bank-select"
								selected={bankOption}
								errorMessage={errors.bankOption}
								onChange={bankOption => this.selectBankOption(bankOption)}
								options={banks}
								name="bank"
								data-action="register-bank-details-bank-select"
								hasSearch={true}
							/>
						</div>
					</div>
					<div className="row">
						<div
							className={`${
								bank == 45 ? "col-xs-12 col-md-6 agency" : "col-xs-16 col-md-8"
							} form-group`}
						>
							<Input
								label="Agência*"
								placeholder="Inserir sua agência"
								name="agency"
								required
								value={agency}
								pattern="\d*"
								inputMode="numeric"
								errorMessage={errors.agency}
								maxLength="4"
								id="agencyId"
								data-action="register-bank-details-agency"
							/>
						</div>
						{bank == 45 && (
							<div className="col-xs-4 col-md-2 form-group digit">
								<Input
									label="Dígito*"
									placeholder="0"
									name="dacAgency"
									maxLength="1"
									required
									value={dacAgency}
									pattern="\d*"
									inputMode="numeric"
									errorMessage={errors.dacAgency}
									id="dacAgencyId"
									data-action="register-bank-details-agency-digit"
								/>
							</div>
						)}

						<div className="col-xs-12 col-md-6 form-group account">
							<Input
								label="Conta corrente*"
								placeholder="Inserir sua conta"
								name="account"
								required
								value={account}
								pattern="\d*"
								inputMode="numeric"
								maxLength="18"
								errorMessage={errors.account}
								data-action="register-bank-details-account"
							/>
						</div>
						<div className="col-xs-4 col-md-2 form-group digit">
							<Input
								label="Dígito*"
								placeholder="0"
								name="dacAccount"
								maxLength="1"
								required
								value={dacAccount}
								pattern="\d*"
								inputMode="numeric"
								errorMessage={errors.dacAccount}
								data-action="register-bank-details-account-digit"
							/>
						</div>
					</div>

					<div className="col-xs-16 no-padding">
						<hr />
					</div>

					<div className="col-xs-16 text-center hidden-xs">
						<span className="form-offer--title">Programa de fidelidade</span>
					</div>

					{this.renderInputs()}
				</form>

				<Steps
					prev={this.saveAndPrevStep}
					next={this.confirmNextStep}
					canPrev={true}
					canNext={true}
				/>

				<Modal
					title="DADOS BANCÁRIOS"
					description={loadingMessage}
					show={showLoading}
					confirm="Fechar"
					onConfirm={() => this.setState({ showLoading: false })}
				/>
			</section>
		);
	}
}

const mapStateToProps = state => ({
	banks: state.createOffer.banks
});

export default connect(mapStateToProps)(RegisterBankDetailsAndLogin);
